

<script lang="ts">
  import type { PermissionState } from "@kontextwerk/control-web-frame/logic/permissions/model"
  import type { PropertiesViewFrameContext } from "../../context"
  import type { PageTabWithId } from "@kontextwerk/web-sdk/core/navigation/viewNavigation"
  import type { PageContext } from "./navigation"
  import UnitsContent from "./_modules/units-content"

  const { viewFrameContext, activeTab } = $props<{
    viewFrameContext: PropertiesViewFrameContext
    activeTab: string
  }>()

  const pageContext = $derived.by<PageContext>(() => ({
    permissions: viewFrameContext.permissions,
    property: viewFrameContext.property,
    organizationId: viewFrameContext.organizationId,
    customers: viewFrameContext.customers,
    propertyLinks: viewFrameContext.propertyLinks,
    canEditCustomers: viewFrameContext.canEditCustomers,
    saving: viewFrameContext.saving,
    onChanged: viewFrameContext.onChanged,
  }))
</script>

{#if activeTab === "units"}
  <UnitsContent
    property={pageContext.property}
    organizationId={pageContext.organizationId}
    customers={pageContext.customers}
    propertyLinks={pageContext.propertyLinks}
    canEdit={pageContext.canEditCustomers && !pageContext.saving}
    onChanged={pageContext.onChanged}
  />
{/if}
